<template>
  <div id="vessel-eingin-input-period-form">
    <div class="flex justify-start items-center gap-4">
      <div class="flat-pickr-wrapper relative">
        <span
          class="
            material-icons-outlined
            absolute
            calendar-icon
            pointer-events-none
          "
        >
          calendar_today
        </span>
        <flat-pickr
          class="vessel-monitaring-engine-calendar start-date"
          v-model="startDateTime"
          placeholder="開始時間を選択"
          :config.sync="configStartPicker"
          ref="startDateTimePicker"
        />
      </div>
      <div>〜</div>
      <div class="flat-pickr-wrapper relative">
        <span
          class="
            material-icons-outlined
            absolute
            calendar-icon
            pointer-events-none
          "
        >
          calendar_today
        </span>
        <flat-pickr
          class="vessel-monitaring-engine-calendar end-date"
          v-model="endDateTime"
          placeholder="終了時間を選択"
          :config.sync="configEndPicker"
          ref="startDateTimePicker"
        />
      </div>
      <div>
        <vs-button
          class="apply-btn"
          :color="AISEA_COLOR.BLUE"
          type="border"
          :disabled="!isValidateApply"
          @click="handleClickApply"
          :style="{
            height: '38px',
            width: '64px',
            padding: 0,
          }"
        >
          適用
        </vs-button>
      </div>
    </div>
    <vs-popup
      class="vessel-eingin-input-period-popup"
      :title="'確認'"
      :active.sync="shouldBeConfirm"
    >
      <div class="flex flex-col gap-6">
        <div class="aisea-text-16-400-black">
          72時間以上の期間を指定すると、表示に時間がかかります。
        </div>
        <div class="flex justify-end gap-6">
          <vs-button
            class="ok-btn aisea-text-14-400-white"
            :color="AISEA_COLOR.BLUE"
            type="filled"
            :disabled="!isValidateApply"
            @click="handleClickOK"
            :style="{
              height: '38px',
              width: '70px',
              padding: 0,
            }"
          >
            OK
          </vs-button>
          <vs-button
            class="cancel-btn aisea-text-14-400-black"
            :color="AISEA_COLOR.WHITE"
            type="filled"
            @click="shouldBeConfirm = false"
            :style="{
              height: '38px',
              width: '124px',
              padding: 0,
            }"
          >
            キャンセル
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moment from "moment";
import { ColorMixin } from "@/mixins";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
const FLAT_PICKR_CLASS_NAME = "flatpickr-calendar";
const VESSEL_ENGINE_FLAT_PICKR_CLASS_NAME =
  "vessel-eingin-input-period-form-calendar";
const STYLE_OVERWRITE = "style-overwrite";
const LONG_PERIOD_HOUR = 72;

export default {
  name: "inputPeriodForm",
  props: {
    applyCallBack: { type: Function, required: true },
  },
  mixins: [ColorMixin],
  components: {
    flatPickr,
  },
  data() {
    return {
      startDateTime: null,
      endDateTime: null,
      configTimePicker: {
        enableTime: true,
        minuteIncrement: 1,
        time_24hr: true,
        dateFormat: "Y-m-d H:i",
        minDate: null,
        maxDate: null,
        minTime: "00:00",
        maxTime: "23:59",
        locale: Japanese,
        monthSelectorType: "static",
        disableMobile: true,
      },
      shouldBeConfirm: false,
    };
  },
  computed: {
    configStartPicker() {
      if (!this.endDateTime) return this.configTimePicker;
      return {
        ...this.configTimePicker,
        maxDate: this.endDateTime,
        maxTime: this.maxStartTime,
      };
    },
    configEndPicker() {
      if (!this.startDateTime) return this.configTimePicker;
      return {
        ...this.configTimePicker,
        minDate: this.startDateTime,
        minTime: this.minEndTime,
      };
    },
    startDate() {
      if (!this.startDateTime) return null;
      return moment(this.startDateTime).format("YYYY-MM-DD");
    },
    startTime() {
      if (!this.startDateTime) return null;
      return moment(this.startDateTime).format("HH:mm");
    },
    endDate() {
      if (!this.endDateTime) return null;
      return moment(this.endDateTime).format("YYYY-MM-DD");
    },
    endTime() {
      if (!this.endDateTime) return null;
      return moment(this.endDateTime).format("HH:mm");
    },
    isStartDateSameEndDate() {
      if (!this.startDateTime) return false;
      if (!this.endDateTime) return false;
      return this.startDate === this.endDate;
    },
    maxStartTime() {
      if (this.isStartDateSameEndDate) return this.endTime;
      return this.configTimePicker.maxTime;
    },
    minEndTime() {
      if (this.isStartDateSameEndDate) return this.startTime;
      return this.configTimePicker.minTime;
    },
    isValidateApply() {
      if (!this.startDateTime) return false;
      if (!this.endDateTime) return false;
      return true;
    },
    periodDiffHour() {
      if (!this.isValidateApply) return null;
      return moment(this.endDateTime).diff(moment(this.startDateTime), "hour");
    },
    isLongPeriod() {
      if (!this.periodDiffHour) return false;
      return Math.abs(this.periodDiffHour) >= LONG_PERIOD_HOUR;
    },
  },
  watch: {},
  methods: {
    handleClickApply() {
      if (this.isLongPeriod) {
        this.shouldBeConfirm = true;
        return;
      }
      this.applyCallBack(
        moment(this.startDateTime).valueOf(),
        moment(this.endDateTime).valueOf(),
      );
    },
    handleClickCancel() {
      this.shouldBeConfirm = false;
    },
    handleClickOK() {
      this.applyCallBack(
        moment(this.startDateTime).valueOf(),
        moment(this.endDateTime).valueOf(),
      );
      this.shouldBeConfirm = false;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    // flatpickrに独自スタイルを当てるためにclass付与
    document.querySelectorAll(`.${FLAT_PICKR_CLASS_NAME}`).forEach((fc) => {
      fc.classList.add(VESSEL_ENGINE_FLAT_PICKR_CLASS_NAME, STYLE_OVERWRITE);
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#vessel-eingin-input-period-form {
  .flatpickr-input {
    padding-left: 46px;
  }
  .flat-pickr-wrapper {
    .calendar-icon {
      font-size: 15px;
      top: 50%;
      left: 16px;
      transform: translate(0%, -50%);
    }
    .flatpickr-input {
      border: solid 1px $aisea-light-gray;
    }
  }
  .flatpickr-input.active {
    border: 1px solid $aisea-blue;
  }
}

.flatpickr-calendar {
  &.vessel-eingin-input-period-form-calendar {
    .flatpickr-current-month {
      display: flex;
      justify-content: center;
      align-items: center;
      align-items: baseline;
      gap: 30px;

      span.cur-month {
        color: #626262;
      }
    }
    .flatpickr-day {
      &.selected,
      &.startRange,
      &.endRange,
      &.selected.inRange,
      &.startRange.inRange,
      &.endRange.inRange,
      &.selected:focus,
      &.startRange:focus,
      &.endRange:focus,
      &.selected:hover,
      &.startRange:hover,
      &.endRange:hover,
      &.selected.prevMonthDay,
      &.startRange.prevMonthDay,
      &.endRange.prevMonthDay,
      &.selected.nextMonthDay,
      &.startRange.nextMonthDay,
      &.endRange.nextMonthDay {
        background: $aisea-blue !important;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-color: $aisea-blue !important;
      }
    }
  }
}
</style>
